import { pickBy } from 'lodash';
import { getUtmCookieValues, setCookie } from '../../../../utils/for-warbler';
import { UnparsedQueryParams } from '../../types';

export const handleUtmParams = ({ params }: { params: UnparsedQueryParams }) => {
  const queryParamUtmParams = pickBy(params, (_, param) => param.startsWith('utm_'));

  // UTM Params are being stored in cookies as well to avoid loss of data
  if (Object.keys(queryParamUtmParams).length > 0) {
    Object.entries(queryParamUtmParams).forEach(([key, value]: [string, string | number]) => {
      setCookie(key, value, 30);
    });
  }

  const cookieValues = getUtmCookieValues();
  const utmParams = { ...queryParamUtmParams, ...cookieValues };
  return utmParams;
};
